import React from 'react';

const Locations = () => {
  const locations = [
    {
      name: 'Konkan Cancer and Multispeciality Hospital, Kudal, MH',
      address: 'Kudal, Maharashtra, India',
      schedule: 'Wed-Fri: 9:30am - 7:00pm',
      directionsUrl: 'https://www.google.com/maps/dir//Kudal+Cancer+Clinic,+Chintamani+plaza,+Kumbharwadi,+Kudal,+Maharashtra+416520,+India/@15.9945898,73.593326,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bc00f3f7bb796db:0x16925fbc8b637d84!2m2!1d73.6757278!2d15.9946055?entry=ttu&g_ep=EgoyMDI1MDcyMy4wIKXMDSoASAFQAw%3D%3D'
    },
    {
      name: 'Vision Hospital, Goa',
      address: 'Goa, India',
      schedule: 'Mon-Tue: 9:30am - 6:00pm',
      directionsUrl: 'https://www.google.com/maps/place/Vision+Hospital+Goa'
    }
  ];

  return (
    <section id="locations" className="section bg-white">
      <div className="container">
        <h2 className="section-title">Practice Locations</h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {locations.map((location, index) => (
            <div key={index} className="card p-8 text-center group hover:shadow-premium-lg transition-all duration-300">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform duration-300">
                <i className="fas fa-hospital text-white text-2xl"></i>
              </div>
              
              <h3 className="font-heading text-2xl font-bold text-primary-700 mb-4 group-hover:text-primary-600 transition-colors duration-300">
                {location.name}
              </h3>
              
              <p className="text-text-muted mb-4">
                {location.address}
              </p>
              
              <p className="text-sm text-text-muted mb-6">
                {location.schedule}
              </p>
              
              <a 
                href={location.directionsUrl} 
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary inline-flex items-center gap-2"
              >
                <i className="fas fa-directions"></i>
                Get Directions
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations; 